import { render, staticRenderFns } from "./AbnormalAccount.vue?vue&type=template&id=67a3d884&scoped=true&"
import script from "./AbnormalAccount.vue?vue&type=script&lang=js&"
export * from "./AbnormalAccount.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalAccount.vue?vue&type=style&index=0&id=67a3d884&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3d884",
  null
  
)

export default component.exports